<div class="h-full flex flex-col w-full gap-2 p-2 min-w-0 overflow-hidden">
    <!-- Top Action Bar - Responsive -->
    <div class="flex flex-wrap md:flex-nowrap items-center justify-between gap-2 w-full min-w-0">
        <div class="flex flex-wrap md:flex-nowrap items-center gap-2 flex-1 min-w-0 w-full md:w-auto">
            <div class="w-full sm:w-auto sm:min-w-[200px]">
                <app-select [(value)]="selectedDocumentType" [options]="documentTypeOptions"
                    [config]="documentTypeConfig" [itemTemplate]="itemTemplateRef"
                    (onChange)="selectDocumentType($event.value)">
                </app-select>
            </div>

            <ng-template #itemTemplateRef let-option>
                <div class="text-sm py-0.5">
                    {{ option.label }}
                </div>
            </ng-template>
            <div class="w-full md:flex-1 md:max-w-md">
                <app-search-bar placeholder="Search by question or answer" [(ngModel)]="searchValue"
                    (searchChange)="onSearch()" width="100%"></app-search-bar>
            </div>
        </div>
        <div class="w-full sm:w-auto flex justify-end">
            <app-button label="Filters" variant="outlined" severity="contrast" icon="pi pi-filter"
                (clicked)="openFilterDialog()" />
        </div>
    </div>

    <!-- Content Area with Proper Overflow Handling -->
    <div class="flex-1 gap-3 flex flex-col min-h-0 overflow-hidden w-full">
        <div class="title font-bold px-2 text-sm sm:text-base">All Questionnaires</div>

        <!-- Selection Action Bar - Responsive -->
        <div class="flex flex-wrap sm:flex-nowrap justify-between border rounded-base p-2 border-gray-200 items-center gap-2 min-w-0"
            *ngIf="selectedItems.length > 0">
            <div class="flex flex-wrap sm:flex-nowrap items-center gap-2 text-sm sm:text-md min-w-0">
                <span *ngIf="!isSelectAll" class="flex-shrink-0">{{ selectedItems.length }} items selected</span>
                <span *ngIf="isSelectAll" class="flex items-center gap-2 flex-shrink-0">
                    <span>All {{ totalRecords }} items selected</span>
                </span>
                <div class="border-l border-gray-300 h-4 mx-2 hidden sm:block"></div>
                <app-button label="Edit Answer" variant="outlined" icon="pi pi-pen-to-square"
                    (clicked)="onBulkEdit()" />
            </div>
            <div class="action-buttons flex items-center gap-2 w-full sm:w-auto justify-end">
                <app-button label="Reject" variant="outlined" icon="pi pi-times" (clicked)="bulkReject()"
                    severity="danger" />
                <app-button label="Approve" variant="outlined" severity="success" icon="pi pi-check"
                    (clicked)="bulkApprove()" />
            </div>
        </div>

        <!-- Data Table with Fixed Height and Overflow -->
        <div class="flex-1 min-h-0 w-full overflow-hidden">
            <app-data-table [data]="qnaData" [columns]="tableColumns" [config]="tableConfigWithHeight" [dataKey]="'_id'"
                [rowClass]="getRowClass" (selectionChange)="onSelectionChange($event)"
                tableClass="rounded-base text-sm fixed-row-height-table w-full" [customTemplates]="templatesMap"
                [customEmptyTemplate]="customEmptyRef" [externalTotalRecords]="totalRecords" [externalPagination]="true"
                [externalFirst]="skip" (pageChange)="onPageChange($event)">
            </app-data-table>
        </div>

        <ng-template #questionTemplateRef let-qna="$implicit">
            <div class="relative w-full h-14 group">
                <i class="pi pi-arrow-up-right-and-arrow-down-left-from-center absolute top-1 right-1 text-xs cursor-pointer p-1 border rounded-base bg-white shadow-md z-10 opacity-0 group-hover:opacity-100 transition-opacity"
                    (click)="openModel(getQuestionTitle(qna), 'Question')"></i>
                <div class="h-full text-sm p-2 line-clamp-3 overflow-hidden" style="max-height: 3rem;">{{
                    getQuestionTitle(qna) }}
                </div>
            </div>
        </ng-template>

        <ng-template #answerTemplateRef let-qna="$implicit">
            <div class="relative w-full h-14 group">
                <i class="pi pi-arrow-up-right-and-arrow-down-left-from-center absolute top-1 right-1 text-xs cursor-pointer p-1 border rounded-base bg-white shadow-md z-10 opacity-0 group-hover:opacity-100 transition-opacity"
                    (click)="openModel(getAnswerValue(qna), 'Answer')"></i>
                <div class="prose prose-compact text-justify text-sm prose-ul:pl-1 prose-ol:pl-2 h-full overflow-y-auto p-2"
                    [innerHTML]="getAnswerValue(qna) | formatText : false" dynamicComponentRenderer
                    style="line-height:1.5rem; max-height: 3.5rem;">
                </div>
            </div>
        </ng-template>

        <ng-template #authorTemplateRef let-qna="$implicit">
            <div class="text-sm text-ellipsis overflow-hidden">
                <app-user-name-display [user]="qna.author" [fallbackText]="getAuthorName(qna)" />
            </div>
        </ng-template>

        <ng-template #dateTemplateRef let-qna="$implicit">
            <div class="text-sm text-ellipsis overflow-hidden">
                {{ getLastEdited(qna) }}
            </div>
        </ng-template>

        <ng-template #documentTemplateRef let-qna="$implicit">
            <div class="text-sm text-ellipsis overflow-hidden">
                {{ getDocumentName(qna) }}
            </div>
        </ng-template>

        <ng-template #sourceTypeTemplateRef let-qna="$implicit">
            <div class="text-sm text-ellipsis overflow-hidden">
                {{ getSourceType(qna) }}
            </div>
        </ng-template>

        <ng-template #customEmptyRef>
            <div class="flex justify-center items-center h-full min-h-[330px]">
                <span class="text-gray-500">No Review Q&A pairs found</span>
            </div>
        </ng-template>
    </div>
</div>

<app-dialog [(visible)]="expandCell" [title]="expandedCellType" (closed)="expandCell = false"
    class="max-w-[70vw] h-[70vh]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="p-8 mx-4 prose prose-lg text-justify prose-ul:pl-4 prose-ol:pl-4 prose-p:mb-4 prose-headings:mb-3 prose-headings:mt-6"
            [innerHTML]="expandedCellContent | formatText : false" dynamicComponentRenderer
            style="line-height: 1.7; max-width: none; margin-left: 2rem; margin-right: 2rem; padding: 2rem;">
        </div>
    </ng-template>
</app-dialog>

<app-dialog [(visible)]="showBulkEditDialog" (closed)="onCancelBulkEdit()"
    class="max-w-[70vw] h-[70vh]" [fullscreenOnMobile]="true">
    <ng-template #headerTemplate>
        <div class="flex items-center gap-2">
            <span class="font-semibold text-lg">Edit Q&amp;A</span>
            <span class="text-sm text-gray-600">({{ currentEditIndex + 1 }}/{{ totalEditingCount }})</span>
        </div>
    </ng-template>
    <ng-template #bodyTemplate>
        <div class="h-full flex flex-row justify-between p-4 gap-4">
            <div class="h-full w-[40%]">
                <div class="qna-cards-container mb-4">
                    <div #qnaCard *ngFor="let pair of editingPairs; let i = index"
                        class="qna-card mb-3 p-3 border rounded-base cursor-pointer transition-all bg-white border-gray-200 shadow-sm"
                        [ngClass]="{'selected-card': currentEditIndex === i}" (click)="selectQnaPair(i)">
                        <div class="overflow-auto">
                            <div class="font-semibold text-sm mb-2 truncate">{{ pair.question }}</div>
                            <div class="text-xs text-gray-600 truncate">{{ pair.answer }}</div>
                        </div>
                        <div>
                            @if(savedPairs.has(i)) {
                            <div class="flex flex-col gap-1 items-center">
                                <i class="pi pi-check-circle text-success"></i>
                                <span class="text-xs text-success">Done</span>
                            </div>
                            } @else if(currentEditIndex === i) {
                            <i class="pi pi-chevron-right font-bold"></i>
                            }
                        </div>
                    </div>
                    @if(isLoadingMorePairs) {
                    <div class="flex justify-center items-center py-4">
                        <p-progressSpinner class="w-6 h-6"></p-progressSpinner>
                    </div>
                    }
                </div>
            </div>
            <div class="h-full w-[60%]">
                <div *ngIf="editingPairs[currentEditIndex]"
                    class="flex flex-col border-2 border-gray-100 rounded-base p-4 h-full">
                    <div class="field">
                        <label for='bulkEditQuestion' class="flex text-sm font-medium mb-2">Question</label>
                        <textarea id='bulkEditQuestion' pInputTextarea
                            [(ngModel)]="editingPairs[currentEditIndex].question"
                            (ngModelChange)="savePair(currentEditIndex)" class="w-full" rows="3"
                            placeholder="Enter question..."></textarea>
                    </div>
                    <div class="field">
                        <label for='bulkEditAnswer' class="flex text-sm font-medium mb-2">Answer</label>
                        <textarea id='bulkEditAnswer' pInputTextarea [(ngModel)]="editingPairs[currentEditIndex].answer"
                            (ngModelChange)="savePair(currentEditIndex)" class="w-full" rows="5"
                            placeholder="Enter answer..."></textarea>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-between items-center w-full">
            <div class="flex items-center gap-2">
                <app-button icon="pi pi-chevron-left" variant="outlined" label="Prev" [disabled]="isPreviousDisabled"
                    (clicked)="navigatePrevious()" iconPos="left" />
                <app-button icon="pi pi-chevron-right" variant="outlined" label="Next" [disabled]="isNextDisabled"
                    (clicked)="navigateNext()" iconPos="right" />
            </div>
            <div class="flex gap-2">
                <app-button label="Cancel" variant="outlined" severity="contrast" icon="pi pi-times"
                    (clicked)="onCancelBulkEdit()" />
                <app-button label="Save" variant="filled" icon="pi pi-save" (clicked)="onSaveBulkEdit()"
                    [disabled]="isSaveDisabled" [loading]="isSaving" severity="primary" />
            </div>
        </div>
    </ng-template>
</app-dialog>



<p-drawer [(visible)]="filterDialog" position="right">
    <ng-template pTemplate="headless">
        <div class="flex items-center justify-between p-4 flex-shrink-0 border-b">
            <span class="text-lg font-semibold">Filter</span>
            <div class="flex gap-2 items-center">
                <app-button variant="outlined" icon="pi pi-times" (clicked)="filterDialog=false" />
            </div>
        </div>
        <div class="flex flex-col h-full justify-between">
            <div class="p-3 gap-y-4 flex flex-col">
                <div>
                    <div class="text-sm font-semibold">
                        Document Name
                    </div>
                    <app-multi-select [options]="filterDocumentNames" [(value)]="selectedDocumentNames"
                        optionLabel="label" optionValue="value"
                        [config]="{placeholder: 'Select Document Name', styleClass: 'border w-full'}">
                    </app-multi-select>
                </div>
                <div>
                    <div class="text-sm font-semibold">
                        Author
                    </div>
                    <app-multi-select [options]="filterAuthors" [(value)]="selectedAuthors" optionLabel="label"
                        optionValue="value" [config]="{placeholder: 'Select Author', styleClass: 'border w-full'}">
                    </app-multi-select>
                </div>
                <div>
                    <div class="text-sm font-semibold">
                        Source Type
                    </div>
                    <app-multi-select [options]="filterSourceTypes" [(value)]="selectedSourceTypes" optionLabel="label"
                        optionValue="value" [config]="{placeholder: 'Select Source Type', styleClass: 'border w-full'}">
                    </app-multi-select>
                </div>
            </div>
            <div class="p-3 flex justify-between gap-2">
                <div class="flex-1 flex justify-start">
                    <app-button label="Clear all and apply" variant="outlined" icon="pi pi-times"
                        (clicked)="clearFilter()" />
                </div>
                <div class="flex-1 flex justify-end">
                    <app-button label="Apply" variant="filled" icon="pi pi-check" (clicked)="applyFilter()"
                        severity="primary" />
                </div>
            </div>
        </div>
    </ng-template>
</p-drawer>